import { render, staticRenderFns } from "./WorkflowActionSendText.vue?vue&type=template&id=e15664e0&scoped=true&"
import script from "./WorkflowActionSendText.vue?vue&type=script&lang=ts&"
export * from "./WorkflowActionSendText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15664e0",
  null
  
)

export default component.exports